export const generateDelayedAnimations = (order: number) => {
  return order * 1000;
};
